import { render, staticRenderFns } from "./edit-user-info.vue?vue&type=template&id=723fba0d&scoped=true"
import script from "./edit-user-info.vue?vue&type=script&lang=js"
export * from "./edit-user-info.vue?vue&type=script&lang=js"
import style0 from "./edit-user-info.vue?vue&type=style&index=0&id=723fba0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723fba0d",
  null
  
)

export default component.exports